import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaHandsHelping } from 'react-icons/fa';

const HelpMe = () => {
  return (
    <div className="main-content">
      <Container className="px-4 py-3" style={{ maxWidth: '900px' }}>
        <div className="d-flex align-items-center gap-3 mb-4">
          <div className="db1-avatar" style={{ width: 48, height: 48, fontSize: '1.2rem' }}>
            <FaHandsHelping />
          </div>
          <div>
            <h2 className="mb-0" style={{ color: '#a70a4a', fontWeight: '600' }}>Help & Support</h2>
            <p style={{ color: '#7f8c9b', fontSize: '0.85rem', marginBottom: 0 }}>Everything you need to know about using the Volunteer Portal</p>
          </div>
        </div>

        <div className="db1-glass-card" style={{ padding: '24px' }}>
          <h5 style={{ fontWeight: 'bold', marginBottom: '15px', color: '#ac2e62' }}>
            Welcome Volunteer!
          </h5>
          <p style={{ color: '#2c3e50' }}>We're here to help you use all features smoothly and resolve your queries.</p>

          <h6 className="mt-4" style={{ fontWeight: 'bold', color: '#2c3e50' }}>
            How to Use:
          </h6>
          <ul style={{ paddingLeft: '1.2rem', color: '#2c3e50' }}>
            <li style={{ marginBottom: "10px" }}>
              <strong>Profile:</strong> In <b>Profile</b>, you can edit your information using the
              Edit option. It also displays your <b>User ID</b> and other details.
            </li>
            <li style={{ marginBottom: "10px" }}>
              <strong>Home:</strong> See <b>TMGF Moments</b> and <b>Events</b> at a glance.
            </li>
            <li style={{ marginBottom: "10px" }}>
              <strong>Event:</strong> View events shared by the NGO. You can participate, and view
              <b> upcoming</b>, <b>past</b>, and <b>completed</b> events with full details.
            </li>
            <li style={{ marginBottom: "10px" }}>
              <strong>Event Initiatives:</strong> Create and manage your own events, track approval status,
              and view feedback from admins. Use <b>Create New Event</b> to propose an initiative.
            </li>
            <li style={{ marginBottom: "10px" }}>
              <strong>Sidebar Navigation:</strong> Use the sidebar on the left to switch between sections.
              On mobile, tap the <b>☰</b> icon to open the sidebar.
            </li>
          </ul>

          <h6 className="mt-4" style={{ fontWeight: 'bold', color: '#2c3e50' }}>Need More Help?</h6>
          <p style={{ color: '#2c3e50' }}>
            If you have any questions or issues, please contact the NGO administrator or reach out via the
            organization's official communication channels.
          </p>
        </div>
      </Container>
    </div>
  );
};

export default HelpMe;
